/**
  Auto loan lead-capture wizard API wrapper

**/

import { api } from "../common/utils"
import {
  AUTO_LOAN_WORKFLOW_CONFIGS_ENDPOINT,
  AUTO_LOAN_WORKFLOW_CONFIG_ENDPOINT
} from "../common/constants"
import {
  AutoLoanWorkflowConfig,
  AutoLoanWorkflowConfigUpsertPayload,
  AutoLoanWorkflowConfigsListResponse
} from "../types"

const autoLoanWorkflow = {
  find: async (
    brand_id: string
  ): Promise<AutoLoanWorkflowConfigsListResponse> => {
    const { data } = await api.get(
      `${AUTO_LOAN_WORKFLOW_CONFIGS_ENDPOINT}?brand_id=${brand_id}`
    )
    return data
  },
  /**
   * With no id the endpoint resolves to the built-in wizard (`id: 0`) — the
   * starting point for a new config.
   */
  getDefaultDetails: async (): Promise<AutoLoanWorkflowConfig> => {
    const { data } = await api.get(`${AUTO_LOAN_WORKFLOW_CONFIG_ENDPOINT}?id=`)
    return data
  },
  updateOrCreate: async (
    payload: AutoLoanWorkflowConfigUpsertPayload
  ): Promise<{ status: string; message?: string; id?: number }> => {
    const { data } = await api.post(AUTO_LOAN_WORKFLOW_CONFIG_ENDPOINT, payload)
    return data
  },
  delete: async (
    id: string | number
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.delete(
      `${AUTO_LOAN_WORKFLOW_CONFIG_ENDPOINT}?id=${id}`
    )
    return data
  }
}

export default autoLoanWorkflow
